module.exports = __webpack_public_path__ + "static/media/hasshoku.76c76074.png";